import type { Locale } from './locales';

/**
 * The locales whose COMPLIANCE copy (disclosures, refusals, tax and privacy
 * wording) is at least partly MACHINE-TRANSLATED and not yet checked by a native
 * speaker.
 *
 * Founder decision, 2026-10-19, in writing: "Considering AI has become much
 * better, you can machine translate the Q9 english sentences in local languages."
 * Until then these strings were held in English on purpose
 * (`english-by-design.json`); they are now translated, and every one of them is
 * recorded in `machine-translated-compliance.json` — the worklist a native
 * speaker clears.
 *
 * This is the runtime twin of the union of `appliesTo` across that manifest's
 * blocks. It is a separate hand-written constant for one reason: importing the
 * JSON to read ten strings would pull its ~420-key list into the bundle, and
 * Conv-30 spent an entire session getting the entry chunk from 339 KB to 104 KB
 * gzip.
 *
 * A HAND-MAINTAINED LIST THAT MIRRORS ANOTHER SOURCE IS EXACTLY WHAT DRIFTS —
 * so it is GATED: `scripts/check-i18n-coverage.mjs` asserts this array equals
 * that union and fails the build on any difference in either direction.
 *
 * When a native speaker has checked every machine-translated string in a
 * locale, remove the locale from BOTH places: the note this drives
 * (`MachineTranslationNote`) then stops rendering for that language.
 */
export const MACHINE_TRANSLATED_COMPLIANCE_LOCALES: Locale[] = [
  'hi-IN',
  'bn-IN',
  'ta-IN',
  'te-IN',
  'mr-IN',
  'kn-IN',
  'gu-IN',
  'pa-IN',
  'as-IN',
  'ml-IN',
];
